module.exports = __webpack_public_path__ + "static/img/file_csv.23a05b1a.png";